import React from 'react';
import PropTypes from 'prop-types';
import { Scrollbars } from 'react-custom-scrollbars';

import styles from './popup.scss';

class Popup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleCloseClick = this.handleCloseClick.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(e) {
        if (this.wrapperRef && !this.wrapperRef.contains(e.target) && this.props.closeOnClickOutside) {
            this.handleCloseClick();
        }
    }

    handleCloseClick() {
        if (this.props.onCloseClick) {
            this.props.onCloseClick();
        }
    }

    render() {
        const { 'data-testid': dataTestId, config = {}, popUpContentWrapperClassName } = this.props;
        const {
            fullScreen, // bool
            topGradient, // bool
            scrollable, // bool
            style, // css style in object format
            showCloseIcon = true, // bool
            noHeader = false, // bool
            title = null,
            isSideBar = false, // bool
            isClosing = false, // bool
        } = config;

        const isIphone = /iPhone/i.test(navigator.userAgent);
        const popupClass = `${styles.popup} ${this.props.popUpClassName || ''} ${scrollable === false ? '' : 'scrollable'} ${isSideBar && (isClosing ? styles.closing : styles.opening)}`;

        return (
            <div className={`${isSideBar ? styles.sidebarOverlay : styles.overlay} ${fullScreen && styles.fullScreen} ${this.props.className}`}>
                <div className={popupClass} style={style} ref={(el) => { this.wrapperRef = el; }} data-testid={dataTestId || undefined}>
                    <div className={`popup-inner-container ${topGradient ? 'top-gradient' : ''}`}>
                        {!noHeader && (
                            <div className={`popup-header`} style={(isSideBar && isIphone) ? { position: 'sticky', top: 0, zIndex: 999 } : null}>
                                {title && (
                                    <div className="popup-title" data-testid={dataTestId && `${dataTestId}.title`}>
                                        {title}
                                    </div>
                                )}
                                {showCloseIcon && (
                                    <div className={`click-area click-area-24`} onClick={this.handleCloseClick} data-testid={dataTestId && `${dataTestId}.close-btn`}>
                                        <i className={`utr utr-close`} />
                                    </div>
                                )}
                            </div>
                        )}
                        <div className={`popup-content-wrapper ${popUpContentWrapperClassName || ''}`}>
                            {scrollable !== true
                                ? (
                                    <div className={`popup-content ${config.noPadding ? 'no-padding' : ''}`}>
                                        {this.props.children}
                                    </div>
                                )
                                : (
                                    <Scrollbars
                                        // style={{ height: 'calc(100% - 42px)' }}
                                        className={`scroll`}
                                        universal={true}
                                    >
                                        <div className={`popup-content ${config.noPadding ? 'no-padding' : ''}`}>
                                            {this.props.children}
                                        </div>
                                    </Scrollbars>
                                )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Popup.propTypes = {
    children: PropTypes.node.isRequired,
    closeOnClickOutside: PropTypes.bool,
    onCloseClick: PropTypes.func,
    popUpClassName: PropTypes.string,
    'data-testid': PropTypes.string,
};

Popup.defaultProps = {
    closeOnClickOutside: false,
    onCloseClick: null,
    popUpClassName: '',
    'data-testid': null,
};

export default Popup;
